import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TimeSlot } from 'src/app/shop/entities/timeSlot';
import { environment } from 'src/environments/environment';

const state = {
  checkoutItems: JSON.parse(localStorage['checkoutItems'] || '[]')
}

@Injectable({
  providedIn: 'root'
})
export class DeliveryTimeService {

  constructor(private router: Router, private httpClient: HttpClient) { }

  public getEditableDeliveryTimes(isDelivery: boolean, day: number)
  {
    return this.httpClient.get(`${environment.apiUrl}/api/deliverytimes/edit/${isDelivery}/${day}`) as Observable<any>;
  }

  public updateDeliveryTimes(timeSlots: Array<TimeSlot>, date: string, isDelvery: boolean)
  {
    return this.httpClient.put(`${environment.apiUrl}/api/deliverytimes/${date}/${isDelvery}`, timeSlots) as Observable<any>;
  }

  public getDeliveryCost()
  {
    return this.httpClient.get(`${environment.apiUrl}/api/deliverytimes/DeliveryFee/`) as Observable<any>;
  }

  public getLeadTime()
  {
    return this.httpClient.get(`${environment.apiUrl}/api/deliverytimes/LeadTime/`) as Observable<any>;
  }

  public getLeadTimeCollection()
  {
    return this.httpClient.get(`${environment.apiUrl}/api/deliverytimes/LeadTimeCollection/`) as Observable<any>;
  }

  public setDeliveryCost(cost: string)
  {
    return this.httpClient.put(`${environment.apiUrl}/api/deliverytimes/SetDeliveryFee/${cost}`, null) as Observable<any>;
  }

  public setDeliveryLeadTime(length: string)
  {
    return this.httpClient.put(`${environment.apiUrl}/api/deliverytimes/SetDeliveryLeadTime/${length}`, null) as Observable<any>;
  }

  public setCollectionLeadTime(length: string)
  {
    return this.httpClient.put(`${environment.apiUrl}/api/deliverytimes/SetCollectionLeadTime/${length}`, null) as Observable<any>;
  }
}
